export default __webpack_public_path__ + "static/media/m_middle_flow_person.94261fec.png";